import {createContext, useContext} from 'react';
import {DefaultThemeName} from '../themes';
import {ThemeName} from '#common/theme/themes';

interface ThemeNameState {
  setThemeName: (themeName: ThemeName) => void;
  themeName: ThemeName;
}

/* v8 ignore next -- @preserve */
export const ThemeNameContext = createContext<ThemeNameState>({
  setThemeName: () => {
    // Defaults to no-op; will be initialized in CurrentThemeProvider
  },
  themeName: DefaultThemeName,
});

export function useThemeName(): ThemeNameState {
  return useContext(ThemeNameContext);
}
